import { useEffect, useState } from "react";
import axios from "axios";

const HOTELS_API = "https://bmtvendorvendorfinal.onrender.com/api/vendor/hotels";
const ROOMS_API  = "https://bmtvendorvendorfinal.onrender.com/api/hotel-rooms";

/* Token helper - VendorHotels.jsx jaisa hi (dono keys check) */
const getToken = () => {
  const t = localStorage.getItem("vendorToken") || localStorage.getItem("token");
  return t && t !== "undefined" && t !== "null" ? t : null;
};
const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

/* Values model ke enum se match karte hain */
const ROOM_TYPES = ["standard","deluxe","super-deluxe","premium","executive","suite","junior-suite","presidential-suite","family-room","studio","villa","dormitory","other"];
const BED_TYPES  = ["single","twin","double","queen","king","super-king","bunk","sofa-bed","multiple","other"];
const VIEW_TYPES = ["no-view","city-view","garden-view","pool-view","mountain-view","sea-view","lake-view","courtyard-view","other"];
const BATH_TYPES = ["private","shared","attached"];
const MEAL_PLANS = ["room-only","breakfast","breakfast-lunch","breakfast-dinner","half-board","full-board","all-meals"];
const AMENITY_CHIPS = ["Safe","Daily Housekeeping","Tea/Coffee Maker","Intercom","Newspaper","Slippers","Bathrobe","Blackout Curtains","Soundproofing","Electric Kettle"];

const AMENITY_FLAGS = [
  ["wifi","📶 WiFi"],["airConditioning","❄️ AC"],["heater","🔥 Heater"],["television","📺 TV"],
  ["smartTv","📱 Smart TV"],["minibar","🍷 Minibar"],["refrigerator","🧊 Refrigerator"],["wardrobe","🚪 Wardrobe"],
  ["workDesk","💼 Work Desk"],["sofa","🛋️ Sofa"],["balcony","🌅 Balcony"],["terrace","🏞️ Terrace"],
  ["kitchen","🍳 Kitchen"],["kitchenette","🥘 Kitchenette"],["washingMachine","🧺 Washing Machine"],
  ["iron","👔 Iron"],["roomService","🛎️ Room Service"],
];

const emptyRoom = {
  roomName:"", roomType:"standard", description:"", shortDescription:"",
  floorNumber:"", roomSize:"", roomSizeUnit:"sqft", viewType:"no-view",
  totalRooms:"1", maxGuests:"2", maxAdults:"2", maxChildren:"0",
  extraGuestAllowed:false, extraGuestCharge:"",
  bedType:"double", bedCount:"1", extraBedAvailable:false, extraBedCharge:"",
  amenities:[],
  wifi:true, airConditioning:true, heater:false, television:true, smartTv:false, minibar:false,
  refrigerator:false, wardrobe:true, workDesk:false, sofa:false, balcony:false, terrace:false,
  kitchen:false, kitchenette:false, washingMachine:false, iron:false, roomService:false,
  bathroomCount:"1", bathroomType:"private", bathtub:false, shower:true, hotWater:true, toiletries:true, hairDryer:false,
  mealPlan:"room-only", breakfastIncluded:false, lunchIncluded:false, dinnerIncluded:false, mealPrice:"",
  basePrice:"", weekendPrice:"", holidayPrice:"", offerPrice:"", taxPercentage:"", serviceChargePercentage:"",
  refundable:true, freeCancellation:false, cancellationDeadlineHours:"24", cancellationPolicy:"",
  instantBooking:true, bookingConfirmationRequired:false, minimumStay:"1", maximumStay:"30",
  coupleFriendly:true, unmarriedCouplesAllowed:true, localIdAllowed:true, childrenAllowed:true,
  petsAllowed:false, smokingAllowed:false, alcoholAllowed:false, partiesAllowed:false, eventsAllowed:false,
  houseRulesText:"", featured:false,
};

export default function VendorHotelRooms({ hotelId: propHotelId, onLoginRequired }) {
  const [hotels, setHotels]     = useState([]);
  const [hotelId, setHotelId]   = useState(propHotelId || "");
  const [rooms, setRooms]       = useState([]);
  const [loadingH, setLoadingH] = useState(true);
  const [loadingR, setLoadingR] = useState(false);
  const [error, setError]       = useState("");
  const [saving, setSaving]     = useState(false);

  const [view, setView]         = useState("list"); // list | form
  const [editing, setEditing]   = useState(null);   // room object or null
  const [rf, setRf]             = useState({ ...emptyRoom });
  const [existing, setExisting] = useState([]);     // urls already saved
  const [newFiles, setNewFiles] = useState([]);
  const [newPrev, setNewPrev]   = useState([]);

  const setR = (k, v) => setRf(p => ({ ...p, [k]: v }));

  const handleErr = (e, fallback) => {
    if (e.response?.status === 401) {
      setError("Session expire ho gaya, dobara login karo");
      if (typeof onLoginRequired === "function") onLoginRequired();
      return;
    }
    setError(e.response?.data?.message || e.message || fallback);
  };

  /* ===== LOAD HOTELS ===== */
  useEffect(() => {
    if (!getToken()) { setError("Not authorized, token missing"); setLoadingH(false); return; }
    (async () => {
      try {
        const r = await axios.get(HOTELS_API, { headers: authHeaders() });
        const d = r.data;
        setHotels(Array.isArray(d) ? d : d?.hotels || d?.data || []);
      } catch (e) { handleErr(e, "Hotels load nahi hue"); }
      finally { setLoadingH(false); }
    })();
    // eslint-disable-next-line
  }, []);

  /* ===== LOAD ROOMS when hotel changes ===== */
  const loadRooms = async (id = hotelId) => {
    if (!id) { setRooms([]); return; }
    setLoadingR(true); setError("");
    try {
      const r = await axios.get(`${ROOMS_API}/hotel/${id}`, { headers: authHeaders() });
      setRooms(r.data.rooms || []);
    } catch (e) { handleErr(e, "Rooms load nahi hue"); setRooms([]); }
    finally { setLoadingR(false); }
  };
  useEffect(() => { loadRooms(); /* eslint-disable-next-line */ }, [hotelId]);

  const selectedHotel = hotels.find(h => h._id === hotelId);

  /* ===== OPEN / CLOSE FORM ===== */
  const openAdd = () => {
    if (!hotelId) { setError("Pehle hotel select karo"); return; }
    setEditing(null); setRf({ ...emptyRoom });
    setExisting([]); setNewFiles([]); setNewPrev([]);
    setError(""); setView("form"); window.scrollTo(0, 0);
  };

  const openEdit = (room) => {
    const n = (v) => (v != null ? String(v) : "");
    const base = { ...emptyRoom };
    Object.keys(base).forEach(k => {
      if (room[k] === undefined || room[k] === null) return;
      base[k] = typeof base[k] === "boolean" ? !!room[k]
              : typeof base[k] === "string"  ? n(room[k])
              : room[k];
    });
    base.amenities = room.amenities || [];
    base.houseRulesText = (room.houseRules || []).join("\n");
    setEditing(room); setRf(base);
    setExisting(room.images || []); setNewFiles([]); setNewPrev([]);
    setError(""); setView("form"); window.scrollTo(0, 0);
  };

  const closeForm = () => {
    setView("list"); setEditing(null); setRf({ ...emptyRoom });
    setExisting([]); setNewFiles([]); setNewPrev([]); setError("");
  };

  /* ===== IMAGES ===== */
  const totalImgs = existing.length + newFiles.length;
  const addImgs = (e) => {
    const files = [...e.target.files].filter(f => f.type.startsWith("image/") && f.size <= 5*1024*1024);
    if (totalImgs + files.length > 10) { setError("Maximum 10 images allowed"); e.target.value=""; return; }
    setNewFiles(p => [...p, ...files]);
    setNewPrev(p => [...p, ...files.map(f => URL.createObjectURL(f))]);
    e.target.value = "";
  };
  const removeNew = (i) => {
    setNewFiles(p => p.filter((_, x) => x !== i));
    setNewPrev(p => p.filter((_, x) => x !== i));
  };
  const removeExisting = async (url) => {
    if (!window.confirm("Ye image delete karni hai?")) return;
    try {
      const r = await axios.put(`${ROOMS_API}/${editing._id}/images/delete`, { imageUrl: url }, { headers: authHeaders() });
      setExisting(r.data.room.images || []);
      setEditing(r.data.room);
      loadRooms();
    } catch (e) { handleErr(e, "Image delete failed"); }
  };

  const toggleChip = (v) => setRf(p => ({
    ...p, amenities: p.amenities.includes(v) ? p.amenities.filter(x => x !== v) : [...p.amenities, v],
  }));

  /* ===== SAVE ===== */
  const submit = async (e) => {
    e.preventDefault();
    if (!hotelId)               return setError("Hotel select karo");
    if (!rf.roomName.trim())    return setError("Room name zaruri hai");
    if (!rf.totalRooms || Number(rf.totalRooms) < 1) return setError("Total rooms kam se kam 1 hone chahiye");
    if (!rf.maxGuests  || Number(rf.maxGuests)  < 1) return setError("Max guests kam se kam 1 hone chahiye");
    if (rf.basePrice === "" || Number(rf.basePrice) < 0) return setError("Base price zaruri hai");

    setSaving(true); setError("");
    const fd = new FormData();
    Object.entries(rf).forEach(([k, v]) => {
      if (k === "houseRulesText") {
        fd.append("houseRules", JSON.stringify(v.split("\n").map(x => x.trim()).filter(Boolean)));
      } else if (k === "amenities") {
        fd.append("amenities", JSON.stringify(v));
      } else if (typeof v === "boolean") {
        fd.append(k, String(v));
      } else if (v !== "" && v != null) {
        fd.append(k, v);
      }
    });
    if (!editing) fd.append("hotelId", hotelId);
    newFiles.forEach(f => fd.append("images", f));

    try {
      if (editing) await axios.put(`${ROOMS_API}/${editing._id}`, fd, { headers: authHeaders() });
      else         await axios.post(ROOMS_API, fd, { headers: authHeaders() });
      closeForm();
      loadRooms();
    } catch (err) { handleErr(err, "Save failed"); window.scrollTo(0, 0); }
    finally { setSaving(false); }
  };

  /* ===== DELETE / STATUS ===== */
  const del = async (id) => {
    if (!window.confirm("Room delete karna hai? Ye wapas nahi aayega.")) return;
    try {
      await axios.delete(`${ROOMS_API}/${id}`, { headers: authHeaders() });
      setRooms(p => p.filter(r => r._id !== id));
    } catch (e) { handleErr(e, "Delete failed"); }
  };

  const changeStatus = async (id, status) => {
    try {
      const r = await axios.put(`${ROOMS_API}/${id}/status`, { status }, { headers: authHeaders() });
      setRooms(p => p.map(x => (x._id === id ? r.data.room : x)));
    } catch (e) { handleErr(e, "Status update failed"); }
  };

  /* ================= RENDER ================= */
  return (
    <div style={st.page}>
      <div style={st.hdr}>
        <div>
          <h1 style={st.h1}>
            🛏️ {view === "form" ? (editing ? "Edit Room" : "Add New Room") : "Hotel Rooms"}
          </h1>
          <p style={st.sub}>
            {view === "form"
              ? `Hotel: ${selectedHotel?.hotelName || "-"}`
              : hotelId ? `${rooms.length} room(s)` : "Pehle hotel select karo"}
          </p>
        </div>
        {view === "form"
          ? <button style={st.btnG} onClick={closeForm}>← Back to Rooms</button>
          : <button style={{...st.btnB, opacity: hotelId ? 1 : 0.5}} onClick={openAdd} disabled={!hotelId}>➕ Add Room</button>}
      </div>

      {error && (
        <div style={st.err}>
          <span>⚠️ {error}</span>
          <button onClick={() => setError("")} style={st.errX}>✕</button>
        </div>
      )}

      {/* ===== STEP 1: HOTEL SELECT (list view) ===== */}
      {view === "list" && (
        <div style={st.card}>
          <label style={st.label}>Step 1: Hotel select karo *</label>
          <select style={st.sel} value={hotelId} onChange={e => setHotelId(e.target.value)} disabled={loadingH}>
            <option value="">{loadingH ? "Loading hotels…" : "-- Select Hotel --"}</option>
            {hotels.map(h => (
              <option key={h._id} value={h._id}>
                {h.hotelName} — {h.city}{h.status ? ` (${h.status})` : ""}
              </option>
            ))}
          </select>
          {!loadingH && hotels.length === 0 && (
            <p style={{color:"#b45309",fontSize:13,marginTop:8}}>Koi hotel nahi mila. Pehle "Manage Hotels" me hotel add karo.</p>
          )}
        </div>
      )}

      {/* ===== ROOMS LIST ===== */}
      {view === "list" && hotelId && (
        loadingR ? <p style={{padding:20}}>Loading rooms…</p>
        : rooms.length === 0 ? (
          <div style={{...st.card, textAlign:"center", padding:48}}>
            <div style={{fontSize:56}}>🛏️</div>
            <p style={{color:"#6b7280"}}>Is hotel me abhi koi room nahi hai.</p>
            <button style={st.btnB} onClick={openAdd}>➕ Add First Room</button>
          </div>
        ) : (
          <div style={st.tblWrap}>
            <table style={st.tbl}>
              <thead>
                <tr>{["Room","Type","Guests","Inventory","Price / Night","Status","Actions"].map(h => <th key={h} style={st.th}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {rooms.map(room => (
                  <tr key={room._id}>
                    <td style={st.td}>
                      <div style={{display:"flex",alignItems:"center",gap:10}}>
                        {room.coverImage || room.images?.[0]
                          ? <img src={room.coverImage || room.images[0]} alt="" style={st.thumb}/>
                          : <div style={st.thumbPh}>🛏️</div>}
                        <div>
                          <strong>{room.roomName}</strong>
                          <div style={st.gray}>{room.roomSize ? `${room.roomSize} ${room.roomSizeUnit}` : ""}</div>
                        </div>
                      </div>
                    </td>
                    <td style={st.td}>{room.roomType}</td>
                    <td style={st.td}>{room.maxGuests} guests<div style={st.gray}>{room.maxAdults}A / {room.maxChildren}C</div></td>
                    <td style={st.td}>Total: {room.totalRooms}<div style={st.gray}>Avail: {room.availableRooms}</div></td>
                    <td style={st.td}>
                      ₹{room.basePrice}
                      {room.offerPrice > 0 && <div style={{fontSize:12,color:"#16a34a"}}>Offer ₹{room.offerPrice}</div>}
                      <div style={st.gray}>Tax {room.taxPercentage}%</div>
                    </td>
                    <td style={st.td}>
                      <select value={room.status} onChange={e => changeStatus(room._id, e.target.value)}
                        style={{...st.statusSel, ...(room.status==="ACTIVE"?st.sActive:room.status==="PENDING"?st.sPending:room.status==="REJECTED"?st.sRej:{})}}>
                        {["DRAFT","PENDING","APPROVED","ACTIVE","INACTIVE","REJECTED"].map(x => (
                          <option key={x} value={x} disabled={["PENDING","APPROVED","REJECTED"].includes(x) && room.status !== x}>{x}</option>
                        ))}
                      </select>
                    </td>
                    <td style={st.td}>
                      <button style={st.editBtn} onClick={() => openEdit(room)}>✏️ Edit</button>
                      <button style={st.delBtn} onClick={() => del(room._id)}>🗑️</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}

      {/* ===== FULL PAGE FORM ===== */}
      {view === "form" && (
        <form onSubmit={submit} style={st.card}>

          <SH>🛏️ Basic Information</SH>
          <div style={st.g3}>
            <F label="Room Name *"><input style={st.inp} value={rf.roomName} onChange={e=>setR("roomName",e.target.value)} placeholder="e.g. Deluxe Room 1"/></F>
            <F label="Room Type *">
              <select style={st.inp} value={rf.roomType} onChange={e=>setR("roomType",e.target.value)}>
                {ROOM_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </F>
            <F label="View Type">
              <select style={st.inp} value={rf.viewType} onChange={e=>setR("viewType",e.target.value)}>
                {VIEW_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </F>
            <F label="Floor Number"><input style={st.inp} value={rf.floorNumber} onChange={e=>setR("floorNumber",e.target.value)} placeholder="2nd Floor"/></F>
            <F label="Room Size"><input type="number" min="0" style={st.inp} value={rf.roomSize} onChange={e=>setR("roomSize",e.target.value)} placeholder="250"/></F>
            <F label="Size Unit">
              <select style={st.inp} value={rf.roomSizeUnit} onChange={e=>setR("roomSizeUnit",e.target.value)}>
                <option value="sqft">sqft</option><option value="sqm">sqm</option>
              </select>
            </F>
          </div>
          <F label="Short Description (max 500)">
            <input style={st.inp} maxLength={500} value={rf.shortDescription} onChange={e=>setR("shortDescription",e.target.value)}/>
          </F>
          <F label="Description">
            <textarea style={{...st.inp,minHeight:80,resize:"vertical"}} value={rf.description} onChange={e=>setR("description",e.target.value)}/>
          </F>

          <SH>👥 Inventory, Guests & Beds</SH>
          <div style={st.g3}>
            <F label="Total Rooms *"><input type="number" min="1" style={st.inp} value={rf.totalRooms} onChange={e=>setR("totalRooms",e.target.value)}/></F>
            <F label="Max Guests *"><input type="number" min="1" style={st.inp} value={rf.maxGuests} onChange={e=>setR("maxGuests",e.target.value)}/></F>
            <F label="Max Adults"><input type="number" min="1" style={st.inp} value={rf.maxAdults} onChange={e=>setR("maxAdults",e.target.value)}/></F>
            <F label="Max Children"><input type="number" min="0" style={st.inp} value={rf.maxChildren} onChange={e=>setR("maxChildren",e.target.value)}/></F>
            <F label="Bed Type">
              <select style={st.inp} value={rf.bedType} onChange={e=>setR("bedType",e.target.value)}>
                {BED_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </F>
            <F label="Bed Count"><input type="number" min="1" style={st.inp} value={rf.bedCount} onChange={e=>setR("bedCount",e.target.value)}/></F>
            <F label="Extra Guest Charge (₹)"><input type="number" min="0" style={st.inp} value={rf.extraGuestCharge} onChange={e=>setR("extraGuestCharge",e.target.value)} disabled={!rf.extraGuestAllowed}/></F>
            <F label="Extra Bed Charge (₹)"><input type="number" min="0" style={st.inp} value={rf.extraBedCharge} onChange={e=>setR("extraBedCharge",e.target.value)} disabled={!rf.extraBedAvailable}/></F>
          </div>
          <div style={st.checks}>
            <Cb label="Extra Guest Allowed" checked={rf.extraGuestAllowed} onChange={v=>setR("extraGuestAllowed",v)}/>
            <Cb label="Extra Bed Available" checked={rf.extraBedAvailable} onChange={v=>setR("extraBedAvailable",v)}/>
          </div>

          <SH>💰 Pricing</SH>
          <div style={st.g3}>
            <F label="Base Price (₹) *"><input type="number" min="0" style={st.inp} value={rf.basePrice} onChange={e=>setR("basePrice",e.target.value)}/></F>
            <F label="Offer Price (₹)"><input type="number" min="0" style={st.inp} value={rf.offerPrice} onChange={e=>setR("offerPrice",e.target.value)}/></F>
            <F label="Weekend Price (₹)"><input type="number" min="0" style={st.inp} value={rf.weekendPrice} onChange={e=>setR("weekendPrice",e.target.value)}/></F>
            <F label="Holiday Price (₹)"><input type="number" min="0" style={st.inp} value={rf.holidayPrice} onChange={e=>setR("holidayPrice",e.target.value)}/></F>
            <F label="Tax %"><input type="number" min="0" max="100" style={st.inp} value={rf.taxPercentage} onChange={e=>setR("taxPercentage",e.target.value)}/></F>
            <F label="Service Charge %"><input type="number" min="0" max="100" style={st.inp} value={rf.serviceChargePercentage} onChange={e=>setR("serviceChargePercentage",e.target.value)}/></F>
          </div>

          <SH>✨ Room Amenities</SH>
          <div style={st.checks}>
            {AMENITY_FLAGS.map(([k, l]) => <Cb key={k} label={l} checked={rf[k]} onChange={v=>setR(k,v)}/>)}
          </div>
          <Label2>Extra Amenities</Label2>
          <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
            {AMENITY_CHIPS.map(c => (
              <button key={c} type="button" onClick={()=>toggleChip(c)}
                style={{...st.chip,...(rf.amenities.includes(c)?st.chipOn:{})}}>{c}</button>
            ))}
          </div>

          <SH>🚿 Bathroom</SH>
          <div style={st.g3}>
            <F label="Bathroom Type">
              <select style={st.inp} value={rf.bathroomType} onChange={e=>setR("bathroomType",e.target.value)}>
                {BATH_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </F>
            <F label="Bathroom Count"><input type="number" min="1" style={st.inp} value={rf.bathroomCount} onChange={e=>setR("bathroomCount",e.target.value)}/></F>
          </div>
          <div style={st.checks}>
            <Cb label="🛁 Bathtub" checked={rf.bathtub} onChange={v=>setR("bathtub",v)}/>
            <Cb label="🚿 Shower" checked={rf.shower} onChange={v=>setR("shower",v)}/>
            <Cb label="♨️ Hot Water" checked={rf.hotWater} onChange={v=>setR("hotWater",v)}/>
            <Cb label="🧴 Toiletries" checked={rf.toiletries} onChange={v=>setR("toiletries",v)}/>
            <Cb label="💨 Hair Dryer" checked={rf.hairDryer} onChange={v=>setR("hairDryer",v)}/>
          </div>

          <SH>🍽️ Meals</SH>
          <div style={st.g3}>
            <F label="Meal Plan">
              <select style={st.inp} value={rf.mealPlan} onChange={e=>setR("mealPlan",e.target.value)}>
                {MEAL_PLANS.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </F>
            <F label="Meal Price (₹)"><input type="number" min="0" style={st.inp} value={rf.mealPrice} onChange={e=>setR("mealPrice",e.target.value)}/></F>
          </div>
          <div style={st.checks}>
            <Cb label="🍳 Breakfast Included" checked={rf.breakfastIncluded} onChange={v=>setR("breakfastIncluded",v)}/>
            <Cb label="🍽️ Lunch Included" checked={rf.lunchIncluded} onChange={v=>setR("lunchIncluded",v)}/>
            <Cb label="🌙 Dinner Included" checked={rf.dinnerIncluded} onChange={v=>setR("dinnerIncluded",v)}/>
          </div>

          <SH>📋 Booking & Cancellation</SH>
          <div style={st.g3}>
            <F label="Cancellation Deadline (hours)"><input type="number" min="0" style={st.inp} value={rf.cancellationDeadlineHours} onChange={e=>setR("cancellationDeadlineHours",e.target.value)}/></F>
            <F label="Minimum Stay (nights)"><input type="number" min="1" style={st.inp} value={rf.minimumStay} onChange={e=>setR("minimumStay",e.target.value)}/></F>
            <F label="Maximum Stay (nights)"><input type="number" min="1" style={st.inp} value={rf.maximumStay} onChange={e=>setR("maximumStay",e.target.value)}/></F>
          </div>
          <div style={st.checks}>
            <Cb label="✅ Refundable" checked={rf.refundable} onChange={v=>setR("refundable",v)}/>
            <Cb label="Free Cancellation" checked={rf.freeCancellation} onChange={v=>setR("freeCancellation",v)}/>
            <Cb label="⚡ Instant Booking" checked={rf.instantBooking} onChange={v=>setR("instantBooking",v)}/>
            <Cb label="Booking Confirmation Required" checked={rf.bookingConfirmationRequired} onChange={v=>setR("bookingConfirmationRequired",v)}/>
          </div>
          <F label="Cancellation Policy">
            <textarea style={{...st.inp,minHeight:70,resize:"vertical"}} value={rf.cancellationPolicy} onChange={e=>setR("cancellationPolicy",e.target.value)}/>
          </F>

          <SH>🏠 Guest Policies</SH>
          <div style={st.checks}>
            <Cb label="Couple Friendly" checked={rf.coupleFriendly} onChange={v=>setR("coupleFriendly",v)}/>
            <Cb label="Unmarried Couples Allowed" checked={rf.unmarriedCouplesAllowed} onChange={v=>setR("unmarriedCouplesAllowed",v)}/>
            <Cb label="Local ID Allowed" checked={rf.localIdAllowed} onChange={v=>setR("localIdAllowed",v)}/>
            <Cb label="Children Allowed" checked={rf.childrenAllowed} onChange={v=>setR("childrenAllowed",v)}/>
            <Cb label="Pets Allowed" checked={rf.petsAllowed} onChange={v=>setR("petsAllowed",v)}/>
            <Cb label="🚬 Smoking Allowed" checked={rf.smokingAllowed} onChange={v=>setR("smokingAllowed",v)}/>
            <Cb label="Alcohol Allowed" checked={rf.alcoholAllowed} onChange={v=>setR("alcoholAllowed",v)}/>
            <Cb label="Parties Allowed" checked={rf.partiesAllowed} onChange={v=>setR("partiesAllowed",v)}/>
            <Cb label="Events Allowed" checked={rf.eventsAllowed} onChange={v=>setR("eventsAllowed",v)}/>
          </div>
          <F label="House Rules (ek line me ek rule)">
            <textarea style={{...st.inp,minHeight:70,resize:"vertical"}} value={rf.houseRulesText} onChange={e=>setR("houseRulesText",e.target.value)}/>
          </F>

          <SH>📸 Room Images (Max 10)</SH>
          <div style={st.gallery}>
            {existing.map(src => (
              <div key={src} style={st.gItem}>
                <img src={src} alt="" style={st.gImg}/>
                <button type="button" style={st.gX} onClick={()=>removeExisting(src)}>✕</button>
              </div>
            ))}
            {newPrev.map((src, i) => (
              <div key={src} style={st.gItem}>
                <img src={src} alt="" style={{...st.gImg,borderColor:"#1a5490"}}/>
                <button type="button" style={st.gX} onClick={()=>removeNew(i)}>✕</button>
              </div>
            ))}
            {totalImgs < 10 && (
              <label style={st.gAdd}>➕ Add
                <input type="file" multiple accept="image/*" hidden onChange={addImgs}/>
              </label>
            )}
          </div>
          <p style={{fontSize:12,color:"#9ca3af"}}>Max 10 images • Max 5MB each • Pehli image cover image banegi</p>

          <div style={{marginTop:12}}><Cb label="⭐ Featured Room" checked={rf.featured} onChange={v=>setR("featured",v)}/></div>

          <div style={st.foot}>
            <button type="button" style={st.btnG} onClick={closeForm} disabled={saving}>Cancel</button>
            <button type="submit" style={st.btnB} disabled={saving}>
              {saving ? "⏳ Saving…" : editing ? "💾 Update Room" : "➕ Add Room"}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

/* ===== small components ===== */
const F  = ({ label, children }) => <div style={{marginBottom:4}}><label style={st.label}>{label}</label>{children}</div>;
const Label2 = ({ children }) => <label style={{...st.label,marginTop:14}}>{children}</label>;
const SH = ({ children }) => <div style={st.sh}>{children}</div>;
const Cb = ({ label, checked, onChange }) => (
  <label style={st.cb}>
    <input type="checkbox" checked={!!checked} onChange={e => onChange(e.target.checked)}/>
    {label}
  </label>
);

/* ===== styles ===== */
const st = {
  page:{maxWidth:1300,margin:"0 auto",padding:"32px 24px",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",background:"#f1f5f9",minHeight:"100vh"},
  hdr:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:12},
  h1:{margin:0,fontSize:26,color:"#0f172a",fontWeight:800},
  sub:{margin:"4px 0 0",color:"#64748b",fontSize:14},
  card:{background:"#fff",borderRadius:12,padding:26,marginBottom:20,boxShadow:"0 1px 4px rgba(0,0,0,0.06)"},
  err:{background:"#fee2e2",color:"#991b1b",padding:"12px 16px",borderRadius:8,marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center"},
  errX:{background:"none",border:"none",fontSize:18,cursor:"pointer",color:"#991b1b"},
  label:{display:"block",fontSize:13,fontWeight:700,color:"#374151",marginBottom:6},
  sel:{width:"100%",maxWidth:520,padding:"11px 14px",fontSize:14,border:"1.5px solid #d1d5db",borderRadius:8,background:"#fff",boxSizing:"border-box"},
  inp:{width:"100%",padding:"10px 12px",fontSize:14,border:"1.5px solid #d1d5db",borderRadius:8,boxSizing:"border-box",fontFamily:"inherit",background:"#fff"},
  g3:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))",gap:16,marginBottom:12},
  checks:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(210px,1fr))",gap:12,margin:"8px 0 12px"},
  cb:{display:"flex",alignItems:"center",gap:8,fontSize:14,color:"#374151",cursor:"pointer"},
  sh:{fontSize:15,fontWeight:800,color:"#1e293b",padding:"10px 0 8px",borderBottom:"2px solid #e2e8f0",margin:"24px 0 14px"},
  chip:{padding:"7px 14px",background:"#f8fafc",border:"1.5px solid #e2e8f0",borderRadius:20,fontSize:13,fontWeight:600,cursor:"pointer",color:"#475569"},
  chipOn:{background:"#1a5490",color:"#fff",borderColor:"#1a5490"},
  gallery:{display:"grid",gridTemplateColumns:"repeat(auto-fill,110px)",gap:12,marginBottom:6},
  gItem:{position:"relative",width:110,height:84},
  gImg:{width:"100%",height:"100%",objectFit:"cover",borderRadius:8,border:"1.5px solid #e2e8f0"},
  gX:{position:"absolute",top:-7,right:-7,background:"#dc2626",color:"#fff",border:"none",borderRadius:"50%",width:22,height:22,cursor:"pointer",fontSize:12},
  gAdd:{width:110,height:84,border:"2px dashed #cbd5e1",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,color:"#94a3b8",cursor:"pointer"},
  foot:{display:"flex",justifyContent:"flex-end",gap:12,borderTop:"1px solid #e2e8f0",marginTop:28,paddingTop:20},
  btnB:{background:"linear-gradient(90deg,#1a5490,#0f3460)",color:"#fff",border:"none",padding:"11px 22px",borderRadius:8,fontWeight:700,cursor:"pointer"},
  btnG:{background:"#e5e7eb",color:"#374151",border:"none",padding:"11px 22px",borderRadius:8,fontWeight:700,cursor:"pointer"},
  tblWrap:{background:"#fff",borderRadius:12,overflow:"auto",boxShadow:"0 1px 4px rgba(0,0,0,0.06)"},
  tbl:{width:"100%",borderCollapse:"collapse"},
  th:{textAlign:"left",padding:"14px 16px",fontSize:12,color:"#666",textTransform:"uppercase",borderBottom:"1px solid #eee",whiteSpace:"nowrap"},
  td:{padding:"14px 16px",borderBottom:"1px solid #f2f2f2",fontSize:14,verticalAlign:"top"},
  thumb:{width:54,height:54,borderRadius:8,objectFit:"cover"},
  thumbPh:{width:54,height:54,borderRadius:8,background:"#f0f0f0",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22},
  gray:{fontSize:12,color:"#999"},
  statusSel:{padding:"6px 10px",borderRadius:20,border:"1px solid #ddd",fontSize:12,fontWeight:700,cursor:"pointer"},
  sActive:{background:"#e3fcef",color:"#1e824c",borderColor:"#1e824c"},
  sPending:{background:"#fff6da",color:"#a8710a",borderColor:"#a8710a"},
  sRej:{background:"#ffe0e0",color:"#c0392b",borderColor:"#c0392b"},
  editBtn:{background:"#eef3fb",color:"#1a5490",border:"none",padding:"6px 10px",borderRadius:6,cursor:"pointer",marginRight:8,fontSize:12,fontWeight:700},
  delBtn:{background:"#ffe0e0",color:"#c0392b",border:"none",padding:"6px 10px",borderRadius:6,cursor:"pointer",fontSize:12,fontWeight:700},
};